module.exports = __webpack_public_path__ + "fonts/4570b93.eot";